import { render, staticRenderFns } from "./CreateCustomerComponent.vue?vue&type=template&id=f66cbf12&scoped=true"
import script from "./CreateCustomerComponent.vue?vue&type=script&lang=js"
export * from "./CreateCustomerComponent.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomerComponent.vue?vue&type=style&index=0&id=f66cbf12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66cbf12",
  null
  
)

export default component.exports